<template>
    <div class="p-px-2 p-py-2">
            <p style="text-align:justify;">
                Es posible inscribir varias personas a la vez a un mismo curso y esto puede realizarse desde:
            </p>
            <ul>
                <li>Formulario de registro completo</li>
                <li>Búsqueda de participante</li>
                <li>Formulario de registro en las opciones</li>
            </ul>
            <p style="text-align:justify;">
                Una vez el participante se haya registrado en la plataforma se puede agregar a la lista mediante la búsqueda ingresando su carnet o correo;
                si un participante ya se ha inscrito previamente en el curso o evento este no se encontrará al buscarlo.
            </p>
            <p style="text-align:justify;">
                Al registrar un participante desde el formulario de registro en el menú, este se agregará a la lista cuando haya finalizado el registro.
            </p>
            <p style="text-align:justify;">
                Es importante considerar que al registrar varias personas a la vez, 
                se realizará un pago único por la totalidad de la cantidad de participantes 
                por el costo de inscripción.
            </p>
            <div class="p-col p-p-0">
                <Button label="Aceptar" icon="pi pi-check" @click="CerrarModal" class="p-px-0 p-button-text p-button-secondary"></Button>
            </div>
        </div>
</template>

<script>
export default{
    name : 'InformacionParticipantes',
    methods : {
        CerrarModal(){
            this.$emit('CerrarModal')
        },
    }
}
</script>
